import React, { useState, useEffect } from "react";
import axios from "axios";
import { T } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TABS = ["All", "Football", "Basketball", "Cricket", "Tennis", "Athletics", "Swimming"];

const statusBadge = (e) => {
  if (e.status === "live" || e.status === "in progress")
    return <span className="inline-flex items-center gap-1 rounded bg-red-500 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-white"><span className="live-pulse h-1.5 w-1.5 rounded-full bg-white" />Live</span>;
  if (e.status === "final")
    return <span className="rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-slate-600">Final</span>;
  return <span className="rounded bg-blue-100 px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-[#0055FF]">Upcoming</span>;
};

export const LiveTicker = ({ compact = false }) => {
  const [events, setEvents] = useState([]);
  const [tab, setTab] = useState("All");

  useEffect(() => {
    axios.get(`${API}/events`, { params: tab !== "All" ? { sport: tab } : {} })
      .then((r) => setEvents(r.data)).catch(() => {});
  }, [tab]);

  const shown = compact ? events.filter((e) => e.status === "live").slice(0, 4) : events;

  return (
    <div data-testid="live-ticker">
      <div className="flex flex-wrap gap-2" data-testid="live-ticker-tabs">
        {TABS.map((t) => (
          <button
            key={t}
            data-testid={`ticker-tab-${t.toLowerCase()}`}
            onClick={() => setTab(t)}
            className={`rounded-full px-4 py-1.5 text-xs font-bold transition-colors ${
              tab === t ? "bg-[#0055FF] text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-[#0055FF] hover:text-[#0055FF]"
            }`}
          >
            {t === "All" ? <T>All</T> : <T>{t}</T>}
          </button>
        ))}
      </div>
      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {shown.map((e) => (
          <div key={e.id} data-testid={`event-card-${e.id}`} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition-all hover:-translate-y-0.5 hover:border-[#0055FF] hover:shadow-md">
            <div className="flex items-center justify-between text-[11px] font-semibold text-slate-500">
              <span className="flex items-center gap-1.5">{statusBadge(e)} {e.sport}</span>
              <span className="font-mono-score">{e.clock}</span>
            </div>
            <div className="mt-3 space-y-2">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-sm font-semibold text-slate-800">{e.home.flag} {e.home.name}</span>
                <span className="font-mono-score text-sm font-bold">{e.home.score}</span>
              </div>
              {e.away.name && (
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-sm font-semibold text-slate-800">{e.away.flag} {e.away.name}</span>
                  <span className="font-mono-score text-sm font-bold">{e.away.score}</span>
                </div>
              )}
            </div>
            <p className="mt-3 border-t border-slate-100 pt-2 text-[11px] text-slate-400">{e.competition}</p>
          </div>
        ))}
        {shown.length === 0 && <p className="col-span-full py-6 text-center text-sm text-slate-500"><T>No events for this sport right now.</T></p>}
      </div>
      <p className="mt-3 text-[11px] italic text-slate-400" data-testid="demo-data-label"><T>Curated demo data — clearly labeled, not a live feed.</T></p>
    </div>
  );
};
